import React from 'react';
import './informal_plus_internships.css';
import { useNavigate } from 'react-router-dom';
export default function InternshipsSection() {
  const navigate = useNavigate();
  return (
    <>
      {/* Internships Section */}
      <section className="internship-section">
        <div id="section-title-descripion">
          <h1 className="internship-title">IYNS National & International Internships</h1>
          <p className="page-content page-content-internships">
            Unlock opportunities to explore cutting-edge science and technology through hands-on
            internships at premier research centers in India and abroad. Designed for passionate
            students, these programs offer real-world exposure, expert mentorship, and a chance to
            connect with leading scientists—shaping the innovators of tomorrow.
          </p>
        </div>

        <div className="internships">
          <div className="internship internship-international">
            {/* Left Column */}
            <div>
              <h2 className="internship__title">International</h2>
              <p className="iternship__italic">
                IYNS, in collaboration with ITER, France, offers a unique three-week international
                internship for Indian school and college students.
              </p>
              <p className="internship__description international__description">
                This program introduces students to the world of science, with a focus on nuclear
                fusion. Participants will engage in workshops, training sessions, and guided site
                visits to the ITER reactor, gaining both theoretical and practical knowledge of its
                systems. While students won’t be involved in radiation-related activities, they’ll
                build global scientific connections that could shape their future careers.
              </p>
            </div>

            {/* Right Column */}
            <div className="col-12 col-md-6">
              <div
                className="shadow-sm h-100"
                style={{
                  borderRadius: '1.5rem',
                  padding: '2.5rem',
                  border: '1px solid #ddd',
                }}
              >
                <h3
                  style={{
                    fontFamily: 'Unbounded',
                    fontSize: '1.75rem',
                    lineHeight: '2.1875rem',
                    color: '#7D7D7D',
                  }}
                >
                  General conditions for the internship
                </h3>
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    color: '#7D7D7D',
                  }}
                >
                  Curious about science, nuclear tech, and clean energy?...
                </p>
                <ul className="internship-conditions">
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Indian Citizen (with a valid Indian passport)
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Students of Class 10–12
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Permission from Your School
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Consent from Your Parents
                  </li>
                </ul>
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    color: '#7D7D7D',
                  }}
                >
                  🚀 Get ready to learn, explore, and connect...
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    navigate('/internship-form', { state: { appliedFor: 'international' } })
                  }
                  style={{
                    background: '#5A2D7C',
                    border: 'none',
                    borderRadius: '0.5rem',
                    fontSize: '1.25rem',
                    fontWeight: 700,
                  }}
                >
                  Register Now!
                </button>
              </div>
            </div>
          </div>

          <div className="internship internship-national">
            <div>
              <h2 className="internship__title">National</h2>
              <p className="iternship__italic">
                IYNS, in collaboration with leading Indian research centers, offers internships for
                school and college students across India.
              </p>
              <p className="internship__description national__description">
                The program allows students to explore science, with a focus on nuclear science,
                climate change, and clean energy. It includes guided visits to research facilities,
                where students gain both theoretical and hands-on experience with scientific systems
                and instruments. While radiation-related activities are excluded, participants will
                have the opportunity to connect with scientists nationwide—building valuable
                networks for the future.
              </p>
            </div>

            {/* Right Column */}
            <div className="col-12 col-md-6">
              <div
                className="shadow-sm h-100"
                style={{
                  borderRadius: '1.5rem',
                  padding: '2.5rem',
                  border: '1px solid #ddd',
                }}
              >
                <h3
                  style={{
                    fontFamily: 'Unbounded',
                    fontSize: '1.75rem',
                    lineHeight: '2.1875rem',
                    color: '#7D7D7D',
                  }}
                >
                  General conditions for the internship
                </h3>
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    color: '#7D7D7D',
                  }}
                >
                  Curious about science, nuclear tech, and clean energy?...
                </p>
                <ul className="internship-conditions">
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Students must be over 14 years of age.
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Valid Indian Passport required at the time of registration
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Unpaid Internship – All expenses (travel, stay, food, etc.) to be covered by
                    student or school
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Mandatory Documents – CV & Letter of Motivation (PDF format)
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Complete All Form Fields – No blanks allowed!
                  </li>
                  <li style={{ fontSize: '1.25rem', color: '#7D7D7D' }}>
                    ✅ Duration – Up to 4 weeks of immersive learning
                  </li>
                </ul>
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    color: '#7D7D7D',
                  }}
                >
                  🚀 Get ready to learn, explore, and connect...
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    navigate('/internship-form', { state: { appliedFor: 'national' } })
                  }
                  style={{
                    background: '#5A2D7C',
                    border: 'none',
                    borderRadius: '0.5rem',
                    fontSize: '1.25rem',
                    fontWeight: 700,
                  }}
                >
                  Register Now!
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
